import BannerWrapper from './BannerWrapper';
export default BannerWrapper;
//# sourceMappingURL=index.js.map